import { render, staticRenderFns } from "./language-picker.vue?vue&type=template&id=34655b13&"
import script from "./language-picker.vue?vue&type=script&lang=js&"
export * from "./language-picker.vue?vue&type=script&lang=js&"
import style0 from "./language-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports